import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/ribeiro/Development/dropdown-component-module/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useState } from 'react';
import { Props, Playground } from 'docz';
import Dropdown from './src/lib';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Dropdown Component is a react component that creates a dropdown menu using many of material design guide styles.`}</p>
    <p><img alt="demogif" src={require("./src/lib/assets/demo.gif")} /></p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`You can install it using `}<inlineCode parentName="p">{`yarn`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn add @redwallsolutions/dropdown-component-module
`}</code></pre>
    <p>{`Or using `}<inlineCode parentName="p">{`npm`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm i @redwallsolutions/dropdown-component-module
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={Dropdown} mdxType="Props" />
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Dropdown Component is very easy to use:`}</p>
    <Playground __position={1} __code={'() => {\n  const [visible, setVisible] = useState(true)\n  return (\n    <div style={{ width: 134, height: 250 }}>\n      <label htmlFor=\"visibility\">Dropdown Visibility</label>\n      <input\n        type=\"checkbox\"\n        onChange={() => {\n          setVisible(!visible)\n        }}\n        checked={visible}\n        style={{ marginBottom: \'50px\' }}\n      />\n      <Dropdown\n        visible={visible}\n        items={[\n          { text: \'Awesome Option\' },\n          { text: \'Second Thing\' },\n          { text: \'I ❤️ Redwall\' },\n        ]}\n      />\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Dropdown
    }} mdxType="Playground">
    {() => {
        const [visible, setVisible] = useState(true);
        return <div style={{
          width: 134,
          height: 250
        }}>    
                    <label htmlFor="visibility">Dropdown Visibility</label>
                    <input type="checkbox" onChange={() => {
            setVisible(!visible);
          }} checked={visible} style={{
            marginBottom: '50px'
          }} />
                    <Dropdown visible={visible} items={[{
            text: 'Awesome Option'
          }, {
            text: 'Second Thing'
          }, {
            text: 'I ❤️ Redwall'
          }]} mdxType="Dropdown" />
	            </div>;
      }}
    </Playground>
    <h3 {...{
      "id": "dark-mode"
    }}>{`Dark Mode`}</h3>
    <p>{`It supports dark mode by passing the `}<inlineCode parentName="p">{`mode`}</inlineCode>{` attribute from `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object. Take a look:`}</p>
    <Playground __position={2} __code={'<div style={{ width: 280, height: 139 }}>\n  <Dropdown\n    theme={{ mode: \'dark\' }}\n    visible={true}\n    items={[\n      { text: \'Another Option\' },\n      { text: \"I\'m a nice option\" },\n      { text: \'VERY LOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOONG\' },\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Dropdown
    }} mdxType="Playground">
    <div style={{
        width: 280,
        height: 139
      }}>
        <Dropdown theme={{
          mode: 'dark'
        }} visible={true} items={[{
          text: 'Another Option'
        }, {
          text: "I'm a nice option"
        }, {
          text: 'VERY LOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOONG'
        }]} mdxType="Dropdown" />
    </div>
    </Playground>
    <h3 {...{
      "id": "origin"
    }}>{`Origin`}</h3>
    <p>{`Dropdown also supports a `}<inlineCode parentName="p">{`origin`}</inlineCode>{` prop. It's a representation of the `}<inlineCode parentName="p">{`transform-origin`}</inlineCode>{` css prop.`}</p>
    <p>{`In this example, we passed a `}<strong parentName="p">{`center`}</strong>{` as origin prop value.`}</p>
    <Playground __position={3} __code={'() => {\n  const [visible, setVisible] = useState(true)\n  return (\n    <div style={{ width: 134, height: 250 }}>\n      <label htmlFor=\"visibility\">Dropdown Visibility</label>\n      <input\n        type=\"checkbox\"\n        onChange={() => {\n          setVisible(!visible)\n        }}\n        checked={visible}\n        style={{ marginBottom: \'50px\' }}\n      />\n      <Dropdown\n        visible={visible}\n        items={[\n          { text: \'Awesome Option\' },\n          { text: \'Second Thing\' },\n          { text: \'I ❤️ Redwall\' },\n        ]}\n        origin=\"center\"\n      />\n    </div>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      useState,
      Props,
      Playground,
      Dropdown
    }} mdxType="Playground">
    {() => {
        const [visible, setVisible] = useState(true);
        return <div style={{
          width: 134,
          height: 250
        }}>    
                    <label htmlFor="visibility">Dropdown Visibility</label>
                    <input type="checkbox" onChange={() => {
            setVisible(!visible);
          }} checked={visible} style={{
            marginBottom: '50px'
          }} />
                    <Dropdown visible={visible} items={[{
            text: 'Awesome Option'
          }, {
            text: 'Second Thing'
          }, {
            text: 'I ❤️ Redwall'
          }]} origin="center" mdxType="Dropdown" />
	            </div>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      